//
//
//
//
//
//
//
//

export default {
  name: 'product-tile-promo-badge',
  props: {
    promo: {
      type: String,
      default: '',
    },
  },
}
